import { Campaign, CampaignFiltersDto, ScrapersDto } from '@api/apiCompat';

interface SourcesObject {
  sourcesData: ScrapersDto[];
  campaignData: Campaign;
  filtersData: CampaignFiltersDto[];
}

export const prefillMatchedSources = ({ sourcesData, campaignData, filtersData }: SourcesObject) => {
  const campaignScrapers = campaignData?.campaign_scrapers || [];

  return sourcesData
    .filter(source => campaignScrapers.some(scraper => +(scraper.scraper_id ?? 0) === +(source.scrapers_id ?? 0)))
    .map(source => {
      const scraperData = campaignScrapers.find(scraper => +(scraper.scraper_id ?? 0) === +(source.scrapers_id ?? 0));
      const freeFilters = filtersData.filter(filter => !filter.price);
      const relatedFilters = campaignData?.camp_filters
        ?.filter(filter => +(filter.scraper_id ?? 0) === +(source.scrapers_id ?? 0))
        .filter(f => freeFilters.find(free => free.key?.toLowerCase() === f.filter_name));

      const filters = relatedFilters?.reduce(
        (acc, filter) => {
          if (filter.filter_name) {
            acc[filter.filter_name] = filter.filter_val;
          }
          return acc;
        },
        { numberOfLeads: scraperData ? scraperData.leads_count : 0 } as Record<string, string | number>,
      );

      return {
        ...source,
        filters,
      };
    });
};
